const animateValue = (element, cb, start = 0, end, duration = 1000) => {
    let startTimestamp = null;

    const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;

        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        const currentValue = Math.floor(progress * (end - start) + start);

        cb(element, currentValue, progress);

        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    };

    window.requestAnimationFrame(step);
};

export const updateHeight = (el, currentValue, progress) =>
    currentValue === 0
        ? el.style.removeProperty("height")
        : progress === 1 && !el.classList.contains("dropdown__content") && !el.classList.contains("vt__tabs")
        ? el.style.setProperty("height", "auto")
        : el.style.setProperty("height", `${currentValue}px`);

export default animateValue;
